var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pop-back"},[_c('exchangeCode',{attrs:{"code":_vm.code,"tips":_vm.tips}}),_c('img',{attrs:{"src":require("../../assets/icon-close.png"),"alt":""},on:{"click":function($event){_vm.close()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }